import { render, staticRenderFns } from "./GoodItem.vue?vue&type=template&id=3fb3a954&"
import script from "./GoodItem.vue?vue&type=script&lang=js&"
export * from "./GoodItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports